import React from 'react'
import { CBadge, CCard, CCardBody, CFormSwitch, CLoadingButton, CSpinner } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCheckAlt } from '@coreui/icons'

// The on/off panel at the top of the Votes page. While voting is off it is the whole page: one
// clear call to switch it on. Once on it shrinks to a status row.
const ActivateVotes = ({ active, loading, toggling, onToggle }) => {
  if (loading) {
    return (
      <CCard className="vt-panel">
        <CCardBody className="d-flex align-items-center gap-2 text-medium-emphasis py-4">
          <CSpinner size="sm" />
          <span>Loading voting settings...</span>
        </CCardBody>
      </CCard>
    )
  }

  if (!active) {
    return (
      <CCard className="vt-panel">
        <CCardBody className="ge-addon-off">
          <div className="ge-addon-off-icon">
            <CIcon icon={cilCheckAlt} size="xxl" />
          </div>
          <h2 className="ge-addon-off-title">Voting is switched off</h2>
          <p className="ge-addon-off-text">
            Switch it on so members can vote for the best players after each fixture. Members
            won&apos;t see voting while it is off.
          </p>
          <CLoadingButton color="primary" loading={toggling} onClick={() => onToggle(true)}>
            <CIcon icon={cilCheckAlt} className="me-1" />
            Turn On Voting
          </CLoadingButton>
        </CCardBody>
      </CCard>
    )
  }

  return (
    <CCard className="vt-panel">
      <CCardBody className="ge-addon-status">
        <div className="ge-stat-icon ge-stat-icon--success">
          <CIcon icon={cilCheckAlt} size="lg" />
        </div>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <h2 className="vt-panel-title">Fixture Voting</h2>
            <CBadge color="success" shape="rounded-pill">
              Active
            </CBadge>
          </div>
          <p className="vt-panel-note">
            Members can vote for players after each fixture. Switching off hides voting but keeps
            every vote already cast.
          </p>
        </div>
        <CFormSwitch
          size="lg"
          id="is_voting_activate"
          label="On"
          checked
          disabled={toggling}
          onChange={(e) => onToggle(e.target.checked)}
        />
      </CCardBody>
    </CCard>
  )
}

export default ActivateVotes
